<script setup lang="ts">
import VisualiseCombineGraphic from '../assets/images/visualise-combine.svg';

type Props = {
  visible: CombineId[];
};

const props = defineProps<Props>();
const { visible } = toRefs(props);

const object = ref<HTMLObjectElement>();

function update(visible: string[], doc: Document) {
  for (const combine of Object.values(allCombines)) {
    const includes = visible.includes(combine.id);
    combine.svgIds.forEach((id) => {
      const found = doc.getElementById(id);
      if (found) {
        found.style.opacity = includes ? '1' : '0';
        found.style.transform = includes ? 'translate(0, 0)' : 'translate(0, 1rem)';
        found.style.transition = 'opacity 200ms ease-out, transform 200ms ease-out';
      }
    });
  }
}

function onObjectLoad() {
  const obj = unref(object);
  if (obj) {
    if (obj.contentDocument) {
      update(unref(visible), obj.contentDocument);
    }
  }
}

watch(
  [visible, object],
  ([visible, object]) => {
    if (object) {
      if (object.contentDocument) {
        update(visible, object.contentDocument);
      }
    }
  },
  { immediate: true },
);
</script>

<template>
  <object
    ref="object"
    class="combine-svg"
    type="image/svg+xml"
    :data="VisualiseCombineGraphic"
    @load="onObjectLoad"
  ></object>
</template>

<style scoped lang="scss"></style>
